<template>
  <div id="app" :class="inAuthView ? '' : 'zoom-90'">
    <router-view />
  </div>
</template>

<script>
import Bus from "@/utils/bus";
import { DANGER } from "@plugins/flash";
import { appendChatBoxScript } from "@/utils/hubspot";
import { isNotUndefinedAndNotNull } from "@/utils/classes";

export default {
  name: "App",
  computed: {
    /**
     * Dérivé du chemin et non d'une liste de noms : une liste se périme en silence. L'écran de
     * saisie du code 2FA a été livré sans y figurer, il héritait donc du zoom 0.80 du
     * back-office que les autres écrans d'authentification n'ont pas — panneaux rabotés à 80 %
     * de la fenêtre et bande vide en bas. Tout écran sous /auth est désormais couvert.
     */
    inAuthView () {
      return this.$route.path.startsWith("/auth");
    },
  },
  beforeCreate () {
    this.$store.commit("layout/setWidth", window.innerWidth);
  },
  created () {
    appendChatBoxScript();
  },
  beforeDestroy () {
    try {
      Bus.$off("on:400-errors-handled");
      Bus.$off("on:500-errors-handled");
    } catch (err) {
      console.error(err);
    }
  },
  mounted () {
    this.$nextTick(function () {
      window.setInterval(() => {
        this.$bus.$emit("load:recent-accesses");
      }, 10000);
    });

    Bus.$on("on:400-errors-handled", (error) => {
      if (isNotUndefinedAndNotNull(error.response.data.violations)) {
        this.$store.dispatch("validator/check", error.response.data);
        for (const violation of error.response.data.violations) {
          this.$flash(null, violation.message);
        }
      } else {
        if (isNotUndefinedAndNotNull(error.response.data.errors)) {
          for (const error of error.response.data.errors) {
            this.$flash(null, error.detail);
          }
        } else if (isNotUndefinedAndNotNull(error.response.data.detail)) {
          // Display the detail field from API response (e.g., for 403 errors)
          this.$flash(null, error.response.data.detail);
        } else {
          this.$flash(null, error.response.data["hydra:description"]);
        }
      }
    });

    // TODO: réactiver quand l'erreur 500 récurrente (toutes les 15min) sera corrigée côté API
    // Bus.$on("on:500-errors-handled", () => {
    //   this.$flash(null, this.$t("general.actions.error-notification"));
    // });

    Bus.$on("on:403-errors-handled", () => {
      this.$flash(null, this.$t("errors.error-403.description"), 8000, DANGER);
    });

    window.addEventListener("resize", () => {
      this.$store.commit("layout/setWidth", window.innerWidth);
    });
  },
};
</script>
<style lang="scss">
.zoom-90 {
  zoom: 0.80;
}

@media only screen and (max-width: 700px) {
  body div#hubspot-messages-iframe-container {
    display: none !important;
  }
}

.school-list .d-inline-flex + .d-inline-flex {
  margin-left: 16px;
}

</style>